//TODO move this outside the frontend
const statusWithColor = {
	UNCOMPLETED: { id: 1, color: '#FF9933' },
	ONE: { id: 1, color: '#f5be50' },
	TWO: { id: 2, color: '#62c655' },
	SUBMITTED_FOR_ANALYSIS: { id: 3, color: '#74c9bb' },
	STUDY_COMPLETED: { id: 4, color: '#848484' },
	ARCHIVED: { id: 4, color: '#848484' },
	REVISION_REQUESTED: { id: 5, color: '#ee6b5f' },
	PENDING_APPROVAL: { id: 6, color: '#FF9933' }
};
const statusWithContrast = {
	UNCOMPLETED: { id: 1, color: '#bfbfbf' },
	ONE: { id: 1, color: '#808080' },
	TWO: { id: 2, color: '#595959' },
	SUBMITTED_FOR_ANALYSIS: { id: 3, color: '#CCCCCC' },
	STUDY_COMPLETED: { id: 4, color: '#848484' },
	ARCHIVED: { id: 4, color: '#848484' },
	REVISION_REQUESTED: { id: 5, color: '#8c8c8c' },
	PENDING_APPROVAL: { id: 6, color: '#bfbfbf' }
};

export const getColorForStudyStatus = (status) => {
	return statusWithColor[status].color;
};
export const getColorForStudyStatus2 = (status) => {
	return statusWithContrast[status].color;
};
